import React from 'react';

import { IconBasePropsWithColor } from './IconBase';

import { colors } from 'styles/cp';

const InformationIcon: React.FC<IconBasePropsWithColor> = ({
  width = 20,
  height = 20,
  color = colors.intuit_blue,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10.0069" cy="10.0049" r="8.335" fill={color} />
      <path
        d="M10.0068 7.50489C10.4672 7.50489 10.8403 7.13172 10.8403 6.67139C10.8403 6.21106 10.4672 5.83789 10.0068 5.83789C9.54651 5.83789 9.17334 6.21106 9.17334 6.67139C9.17334 7.13172 9.54651 7.50489 10.0068 7.50489Z"
        fill={colors.white}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33984 13.3394C8.33984 12.8791 8.71301 12.5059 9.17334 12.5059H10.8403C11.3007 12.5059 11.6738 12.8791 11.6738 13.3394C11.6738 13.7997 11.3007 14.1729 10.8403 14.1729H9.17334C8.71301 14.1729 8.33984 13.7997 8.33984 13.3394Z"
        fill={colors.white}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33984 9.17189C8.33984 8.71156 8.71301 8.33839 9.17334 8.33839H10.0068C10.2282 8.33839 10.4404 8.42643 10.5968 8.58311C10.7532 8.73978 10.8408 8.95221 10.8403 9.17356L10.832 13.3411C10.8311 13.8014 10.4572 14.1738 9.99684 14.1729C9.53651 14.172 9.16409 13.7981 9.16501 13.3377L9.17168 10.0054C8.71211 10.0045 8.33984 9.63166 8.33984 9.17189Z"
        fill={colors.white}
      />
    </svg>
  );
};

export default InformationIcon;
